export default {"src":"/_next/static/media/opensea.52d0d217.svg","height":31,"width":136};